import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import { OnChange } from 'react-final-form-listeners';
import * as actions from '../../actions';
import {
    isRequiredText,
    isRequiredSignature,
    isRequiredPhoneNumber,
    isRequiredStateSelection,
    isRequiredZipCode,
    numberValidator,
    isRequired,
    isRequiredSelection,
    isRequiredSelectionCheckbox,
    isRequiredQuestionSelection,
    conditionallyRequiredText,




} from '../helpers/Validation';
import { stateList, textField } from '../helpers/Form';
import SignatureCanvas from 'react-signature-canvas';
import prescriber from '../terms/prescriber';
import arrowUp from '../../assets/images/arrow-up.png';
import arrowDown from '../../assets/images/arrow-down.png';
import SignatureDate from '../hooks/SignatureDate';

class Step3 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            prescriberAgentSignature: null,
            prescriberAgentSignatureDate: null,
            confirmDiagnosis: null,
            preferredContact: null,
            conditionallyRequiredText,
        }
    }

    // Used to restore sigs
    componentDidMount() {
        const {
            prescriberAgentSignature,
            confirmDose
        } = this.props.questionOptions;

        const options = {
            minWidth: 0.5,
        }
        if (prescriberAgentSignature) {
            this[("prescriberAgentSignatureRef")].fromDataURL(prescriberAgentSignature, options);
        }
    }

    clearSigCanvas = (refName) => {
        this[(refName + "Ref")].clear();
    }

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[(refName + "Ref")].getTrimmedCanvas().toDataURL()
        })
        this.props.questionAnswer(refName, this[(refName + "Ref")].toDataURL());
    }

    toggleTextBox = (name) => {
        this.setState({
            ...this.state,
            [name]: !this.state[name]
        });
        this.prescriberTextBox.current.scrollIntoView({ behavior: "smooth" });
    }

    primaryContactFaxPhoneTwo = createRef();
    primaryContactFaxPhoneThree = createRef();
    primaryContactPhoneTwo = createRef();
    primaryContactPhoneThree = createRef();
    prescriberTextBox = createRef();

    render() {
        const { currentStep } = this.props;
        const {
            prescriberTextBox
        } = this.state;
        const {
            preferredContact,
            primaryContactFaxPhoneOne,
            primaryContactFaxPhoneTwo,
            primaryContactFaxPhoneThree,
            primaryContactPhoneOne,
            primaryContactPhoneTwo,
            primaryContactPhoneThree,
            prescriberAgentSignature,
            prescriberAgentSignatureDate,
            confirmDose,
            confirmDiagnosis
        } = this.props.questionOptions;
        const todaysDate = new Date().toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" });

        return (
            <Fragment>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-3">
                        <h3 className="euclid">DIAGNOSIS & PRESCRIBER INFORMATION</h3>
                        <div className="d-inline-block">*<i class="required-field-indication">&nbsp;Indicates required field.</i></div>

                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>

                <div className="row spacer-medium" ref={this.toTop}>&nbsp;</div>
                <div className="row">
                    <div className="col">
                        <Field name="confirmDiagnosis">
                            {({ input, meta }) => (
                                <label className={meta.error && meta.touched ? "blue-font error" : "blue-font confirm-diagnosis"}>Confirmation of diagnosis is required*</label>
                            )}
                        </Field>
                    </div>
                </div>
                <div id="confirm-diagnosis-radios" className="row">
                    <div className="col">
                        <div className="form-group">
                            <div className="row">
                                <div className="col">
                                    <div className="radio-field" style={{display: 'flex'}}>
                                        <Field
                                            name="confirmDiagnosis"
                                            component="input"
                                            type="radio"
                                            value="diagnosis"
                                            className=""
                                            id="diagnosis"

                                            onClick={(e) => this.props.questionAnswer("confirmDiagnosis", "Hallucinations and delusions associated with PD psychosis")}
                                        />
                                        <label className="" htmlFor="diagnosis">
                                            Hallucinations and delusions associated with Parkinson&#8217;s disease psychosis (PDP)
                                        </label>
                                    </div>
                                    <div className="radio-field" style={{display: 'flex'}}>
                                        <Field
                                            name="confirmDiagnosis"
                                            component="input"
                                            type="radio"
                                            value="other"
                                            className=""
                                            id="other"
                                            onClick={(e) => this.props.questionAnswer("confirmDiagnosis", "other")}
                                        />
                                        <label className="" htmlFor="other">
                                        Other diagnosis
                                        </label>
                                    </div>
                                    <Field name="confirmDiagnosis" component="input" validate={isRequiredSelection}>
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input {...input} type="text" className="form-control full-width-input hidden-field" tabIndex="-1" />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {confirmDiagnosis === "other" && (
                    <div id="diagnosisName" className="row">
                        <div className="col-sm">
                            <Field
                                name="diagnosis"
                                label=""
                                component={textField}
                                validate={isRequiredText}
                                placeholder="Description*"
                            />
                        </div>
                    </div>
                )}






                <div id="confirm-dose-radios" className="row">
                    <div className="form-group">
                        <div className="col-sm">
                            <Field name="confirmDose">
                                {({ input, meta }) => (
                                    <label className={meta.error && meta.touched ? "blue-font error" : "blue-font"}>Please confirm dose*</label>
                                )}
                            </Field>
                            <div class="row">
                                <div class="col">
                                    <div className="radio-field">
                                        <Field name="confirmDose" type="radio" className="">
                                            {({ input, meta }) => {
                                                return(
                                                    <Fragment>
                                                        <input
                                                            className=""
                                                            id="confirmDose34mg"
                                                            name={input.name}
                                                            type="radio"
                                                            onClick={(e) => this.props.questionAnswer("confirmDose", "34 mg capsule")}
                                                        />
                                                    </Fragment>);
                                            }}
                                        </Field>
                                        <label className="" htmlFor="confirmDose34mg">34 mg capsule</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div className="radio-field">
                                        <Field name="confirmDose" type="radio" className="">
                                            {({ input, meta }) => {
                                                return(
                                                    <Fragment>
                                                        <input
                                                            className=""
                                                            id="confirmDoseOther"
                                                            name={input.name}
                                                            type="radio"
                                                            onClick={(e) => this.props.questionAnswer("confirmDose", "Other")}
                                                        />
                                                    </Fragment>);
                                            }}
                                        </Field>
                                        <label className="" htmlFor="confirmDoseOther">Other</label>
                                    </div>
                                </div>
                            </div>




                            <Field
                                name="confirmDose"
                                component="input"
                                defaultValue={confirmDose}
                                validate={isRequiredQuestionSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>

                {confirmDose === "Other" && (
                    <div id="doseDescription" className="row">
                        <div className="col-sm">
                            <Field
                                name="doseDescription"
                                label=""
                                component={textField}
                                validate={isRequiredText}
                                placeholder="Description*"
                            />
                        </div>
                    </div>
                )}




                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="prescriberAgentName"
                            label="Prescriber first and last name*"
                            placeholder=""
                            component={textField}
                            validate={isRequiredText}

                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="prescriberNpiNumber"
                            label="Prescriber NPI number*"
                            placeholder=""
                            component={textField}
                            validate={isRequiredText}
                            maxLength={10}
                            inputMode="numeric"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="stateLicenseNumber"
                            label="State license number (if available)"
                            placeholder=""
                            component={textField}
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="practiceFacilityName"
                            label="Practice/facility name"
                            placeholder=""
                            component={textField}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="prescriberAddress"
                            label="Address*"
                            placeholder=""
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="prescriberCity"
                            label="City*"
                            placeholder=""
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-8 prescriberState">
                        <div className="form-group" style={{top: '-7px'}}>
                            <Field
                                name="prescriberState"
                                component="select"
                                validate={isRequiredStateSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.error && meta.touched ? "error" : ""} htmlFor="state" style={{marginBottom: '0px'}}>State*</label>
                                        <select {...input} className={meta.error && meta.touched ? "select-state-css select-css error" : "select-state-css select-css"} type="select" style={{marginTop: '0px'}}>
                                            <option name="" value="">- Select state -</option>
                                            {Object.entries(stateList).map(function (state) {
                                                return (<option key={state[0]} name="state" value={state[0]}>{state[1]}</option>);
                                            })}
                                        </select>
                                        {meta.error && meta.touched && meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <Field
                                name="prescriberZipCode"
                                label="ZIP*"
                                placeholder=""
                                component={textField}
                                validate={isRequiredZipCode}
                                maxLength={5}
                                inputMode="numeric"
                            />
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <Field
                                name="primaryContactName"
                                label="Primary contact name"
                                component={textField}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <Field
                            name="prescriberEmail"
                            label="Prescriber email"
                            component={textField}
                            key={(preferredContact === "patient" || !preferredContact) ? 1 : 0}
                            forwardRef={this.prescriberEmail}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm">
                        <div className="form-group">
                            <div className="phone-group">
                                <Field name="primaryContactPhoneNumber" component="input" defaultValue={String(primaryContactPhoneOne + primaryContactPhoneTwo + primaryContactPhoneThree)}
                                    validate={isRequiredPhoneNumber}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <label className={meta.error && meta.touched ? "error" : ""}>Phone number*</label>
                                        </Fragment>
                                    )}
                                </Field>
                                <Field name="primaryContactPhoneOne" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-area-code error" : "form-control inline-phone phone-area-code"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                                inputMode="numeric"
                                            />
                                            {meta.error && meta.touched && meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="primaryContactPhoneOne">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer("primaryContactPhoneOne", value);
                                            if (value.length === 3) {
                                                this.primaryContactPhoneTwo.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field name="primaryContactPhoneTwo" component="input" validate={isRequired} >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-prefix error" : "form-control inline-phone phone-prefix"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.primaryContactPhoneTwo}
                                                inputMode="numeric"
                                            />
                                            {meta.error && meta.touched && meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="primaryContactPhoneTwo">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer("primaryContactPhoneTwo", value);
                                            if (value.length === 3) {
                                                this.primaryContactPhoneThree.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field name="primaryContactPhoneThree" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-line-number error" : "form-control inline-phone phone-line-number"}
                                                type="text"
                                                maxLength="4"
                                                placeholder="7890"
                                                ref={this.primaryContactPhoneThree}
                                                inputMode="numeric"
                                            />
                                            {meta.error && meta.touched && meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="primaryContactPhoneThree">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer("primaryContactPhoneThree", value);
                                        }
                                    }}
                                </OnChange>
                            </div>
                            <Field name="primaryContactPhoneNumber" component="input" defaultValue={String(primaryContactPhoneOne + primaryContactPhoneTwo + primaryContactPhoneThree)}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="form-group">
                            <div className="phone-group">
                                <Field name="primaryContactFaxNumber" component="input" defaultValue={String(primaryContactFaxPhoneOne + primaryContactFaxPhoneTwo + primaryContactFaxPhoneThree)}
                                    validate={isRequiredPhoneNumber}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <label className={meta.error && meta.touched ? "error" : ""}>Fax*</label>
                                        </Fragment>
                                    )}
                                </Field>
                                <Field name="primaryContactFaxPhoneOne" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-area-code error" : "form-control inline-phone phone-area-code"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                                inputMode="numeric"
                                            />
                                            {meta.error && meta.touched && meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="primaryContactFaxPhoneOne">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer("primaryContactFaxPhoneOne", value);
                                            if (value.length === 3) {
                                                this.primaryContactFaxPhoneTwo.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field name="primaryContactFaxPhoneTwo" component="input" validate={isRequired} >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-prefix error" : "form-control inline-phone phone-prefix"}
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.primaryContactFaxPhoneTwo}
                                                inputMode="numeric"
                                            />
                                            {meta.error && meta.touched && meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="primaryContactFaxPhoneTwo">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer("primaryContactFaxPhoneTwo", value);
                                            if (value.length === 3) {
                                                this.primaryContactFaxPhoneThree.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field name="primaryContactFaxPhoneThree" component="input" validate={isRequired}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-line-number error" : "form-control inline-phone phone-line-number"}
                                                type="text"
                                                maxLength="4"
                                                placeholder="7890"
                                                ref={this.primaryContactFaxPhoneThree}
                                                inputMode="numeric"
                                            />
                                            {meta.error && meta.touched && meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="primaryContactFaxPhoneThree">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer("primaryContactFaxPhoneThree", value);
                                        }
                                    }}
                                </OnChange>
                            </div>
                            <Field name="primaryContactFaxNumber" component="input" defaultValue={String(primaryContactFaxPhoneOne + primaryContactFaxPhoneTwo + primaryContactFaxPhoneThree)}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="hipaa prescriber-authorization" ref={this.prescriberTextBox}>
                    <div className={"scroll-terms " + (prescriberTextBox ? "expanded" : "condensed")}>
                        {prescriber}
                    </div>
                    <button className="btn no-outline" onClick={() => this.toggleTextBox("prescriberTextBox")} type="button">
                        SEE {prescriberTextBox ? <Fragment>LESS<img className="arrow" src={arrowUp} alt="arrrow"/></Fragment> : <Fragment>MORE<img className="arrow" src={arrowDown} alt="arrrow" /></Fragment>}
                    </button>
                    <div className="row spacer-small" />
                    <div className="form-group">
                        <Field
                            name="prescriberAgentSignature"
                            validate={isRequiredSignature}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "error" : ""} htmlFor="prescriberAgentSignature">Prescriber or authorized agent signature*</label>
                                </Fragment>
                            )}
                        </Field>

                        <div className="text-center relative bt-neg-10px-mobile">
                            <SignatureCanvas
                            penColor='black'
                            canvasProps={{height: 200, className: 'sig-canvas'}}
                            onEnd={() => this.storeSigData("prescriberAgentSignature")}
                            ref={(ref) => { this.prescriberAgentSignatureRef = ref }}
                            clearOnResize={false}
                            />
                            <button type="button" className="canvas-clear" onClick={() => this.clearSigCanvas("prescriberAgentSignature")}>CLEAR</button>
                            <Field name="prescriberAgentSignature" defaultValue={prescriberAgentSignature} component="input" validate={isRequiredSignature}>
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <SignatureDate forDate="prescriberAgentSignature"/>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
}

  export default connect(mapStateToProps, actions)(Step3);
